<template>
  <div class="tables">
    <div class="container">
      <div class="row">
        <Navigation calculators />
        <Tables />
      </div>
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Tables from '../../../components/Calculators/Content/Tables';
import Navigation from '../../../components/Calculators/Navigation';

export default {
  components: {
    Tables, Navigation,
  },
  mixins: [global],
  data() {
    return {
      metaData: {
        'snd-table': [
          'Standard Normal Distribution Table',
          'This z-score table contains the standard normal distribution critical values and the corresponding (1-α). Find the z-score you need here.',
        ],
        'std-table': [
          'Student’s T Distribution Table',
          'The Student’s t-distribution table contains the t-distribution critical values by confidence level and degrees of freedom. Find the t score you need here.',
        ],
        'fd-table': [
          'F-Distribution Critical Values Table',
          'The F-distribution table provides critical values for different levels of significance (alpha) and degrees of freedom. Find the value you need here.',
        ],
      },
    };
  },
  head() {
    return {
      titleTemplate: `${this.metaData[this.$route.path.split('/')[3]][0]} | 365 Data Science`,
      meta: this.metaProps({ metaDescription: this.metaData[this.$route.path.split('/')[3]][1] }),
      script: [
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_SVG', async: true },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tables {
  overflow: hidden;
  padding-top: var(--spacing-160);
  background: var(--main-light-shade-1);
}

@include bp($bp-mobile) {
  .tables {
    padding-top: 124px;

    .container {
      padding: 0;
    }
  }

  .col.col-4::v-deep {
    .tools {
      margin-bottom: 64px;
    }
  }
}
</style>
